import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { Amplify } from 'aws-amplify';
import { environment } from './environments/environment';

import { LicenseManager } from 'ag-grid-enterprise';
import 'ag-grid-enterprise';

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));

const agGridLicenseKey =
  'Using_this_{AG_Grid}_Enterprise_key_{AG-066940}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Terabase_Energy,_Inc.}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{Terabase_Construct}_only_for_{4}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_working_on_{Terabase_Construct}_need_to_be_licensed___{Terabase_Construct}_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{19_October_2025}____[v3]_[01]_MTc2MDgyODQwMDAwMA==9b6c127a964880c35447138fae817244';

LicenseManager.setLicenseKey(agGridLicenseKey);

const { region, clientId, userPool, responseType, identityPoolId } =
  environment.authConfig;

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: userPool,
      userPoolClientId: clientId,
      identityPoolId: `${region}:${identityPoolId}`,
      loginWith: {
        oauth: {
          domain: environment.authDomain,
          responseType,
          redirectSignIn: [window.location.origin],
          redirectSignOut: [window.location.origin],
          scopes: [
            'phone',
            'email',
            'profile',
            'openid',
            'aws.cognito.signin.user.admin',
          ],
        },
      },
    },
  },
});
